





















































































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { State } from 'vuex-class';
import AddRgTemplate from './components/add-rg-template.vue';
/**
 * rg模板列表
 *
 * @author xiaokunyu
 * @date 03/28/2019
 */
@Component({
    components: {
        AddRgTemplate
    }
})
export default class RgTemplate extends PaginationMixin {
    @State(state => state.cti.permission.rg_template)
    permission: boolean;

    templateList: any = [];
    addTemplateVisible: Boolean = false;
    editTemplateVisible: Boolean = false;

    rgId: number = 0;
    tableLoading: Boolean = true;
    $mtd: any;

    templateId: number = 0;
    hoverContent: string = '';
    mounted() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.getTemplateList();
    }
    async getTemplateList() {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getRgTemplate({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.templateList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getTemplateList();
                }
                this.templateList = data.items;
            }
        } catch (e) {
            this.templateList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getTemplateList();
    }
    async handleCatalogDetail(id: number, bindCTI: number) {
        if (bindCTI === 0) {
        } else {
            this.hoverContent = await this.getCatalogByTemplate(id);
        }
    }
    // 通过模板id获取绑定目录
    async getCatalogByTemplate(id: number) {
        try {
            const res = await api.rgApi.getCatalogByTemplate(id, 'NORMAL');
            const { code, data } = res;
            if (code === 200) {
                const displayList = data.items.map(catalog => {
                    let display = `${catalog.categoryName}／${catalog.typeName}`;
                    if (catalog.itemName) {
                        display += `／${catalog.itemName}`;
                    }
                    return display;
                });
                return displayList.join('</br>');
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 复制rg模板
    async handleCopyTemplate(row: any) {
        const content = await this.getTemplateDetail(row.id);
        if (!row.crud.copy) {
            return;
        }
        try {
            await api.rgApi.addRgTemplate({
                name: row.name + '-副本',
                content: content,
                rgId: this.rgId
            });
            this.$mtd.message.success('模板复制成功');
            this.getTemplateList();
        } catch (e) {
            console.log(e);
        }
    }
    // 获取模板content
    async getTemplateDetail(templateId) {
        try {
            const res = await api.rgApi.getTemplateById(templateId);
            const { code, data } = res;
            if (code === 200) {
                return data.content;
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 编辑rg模板
    handleEditTemplate(id: number, control: Boolean) {
        if (!control) {
            return;
        }
        this.templateId = id;
        this.editTemplateVisible = true;
    }
    // 删除rg模板
    handleDeleteTemplate(id: number, bindCTI: Boolean, control: Boolean) {
        if (!control) {
            return;
        }
        if (bindCTI) {
            this.unableDelete();
            return;
        }
        this.$mtd
            .confirm({
                title: '你是否确认删除该模板？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.rgApi.deleteRgTemplate(id);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await this.getTemplateList();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    // 不允许删除模板提示
    unableDelete() {
        this.$mtd
            .confirm({
                title: '目前已经绑定了目录，暂时无法删除',
                type: 'warning',
                width: '433px',
                okButtonText: '知道了'
            })
            .catch(e => e);
    }
}
